// Port of api/fuel/app/classes/filter/search/games/sorts/query/play/plays/count.php
import F from 'offline/filter/constants'
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'
export default {
	name: 'plays',
	post: false,
	require: function(config, filter) {
		var isGameOrCollection = config.resultType === F.RESULT_GAME || config.resultType === F.RESULT_COLLECTION
		if (!isGameOrCollection) return false

		var hasDateRange = (
			filter.played.range.from || filter.played.range.to ||
			filter.played.sometime.from || filter.played.sometime.to ||
			filter.played.never.from || filter.played.never.to ||
			filter.played.first.from || filter.played.first.to ||
			filter.played.last.from || filter.played.last.to
		)

		if (sorted('plays.all', filter) > 0 && !hasDateRange) return true
		if (sorted('plays.context', filter) > 0 && hasDateRange) return true
		if (sorted('plays', filter) > 0) return true

		return false
	},
	run: function(config, filter, data, query) {
		query.order('SUM(p.play_count)', sortReverse(['plays', 'plays.context', 'plays.all'], filter), sortPriority(['plays', 'plays.context', 'plays.all'], filter))
		query.leftjoin('p')
	}
}
